import { useQuery } from '@tanstack/react-query';
import { appVersionApi } from '@/api/appVersionApi';

export const appVersionKeys = {
  policy: ['app-version-policy'] as const
};

/** Poll cadence for the informational version policy. */
export const APP_VERSION_POLL_MS = 1000 * 60 * 5;

/**
 * Polls the informational version policy (C.3 client) on mount and every five
 * minutes. `fetchPolicy` never throws — it resolves to the cached policy or
 * `null` — so this query effectively never errors and consumers treat
 * `null`/`undefined` as "unknown". `networkMode: 'always'` keeps the poll alive
 * while offline so a maintenance window can clear without a manual refresh.
 */
export const useAppVersion = () =>
  useQuery({
    queryKey: appVersionKeys.policy,
    queryFn: () => appVersionApi.fetchPolicy(),
    refetchInterval: APP_VERSION_POLL_MS,
    refetchIntervalInBackground: true,
    staleTime: APP_VERSION_POLL_MS,
    networkMode: 'always'
  });
